export default "__VITE_ASSET__CrHB7dWN__"